import React from "react";
import PropTypes from "prop-types";
import { WizardTitle } from "../../../../components/Utils";

import { connect } from "react-redux";

const mapStateToProps = (state) => {
  return {
    order: state.key.keyOrder,
  };
};
const mapDispatchToProps = null;

class KeyOrderWizardTitle extends React.Component {
  static propTypes = {
    // mapped from state
    order: PropTypes.object,
    // from parent
    match: PropTypes.object,
    history: PropTypes.object,
    isTask: PropTypes.bool,
  };
  constructor(props) {
    super(props);
    this.state = { menu: null };
  }
  setNavMenu = (menu) => {
    console.log("KeyOrderWizardTitle.setNavMenu()", menu);
    this.setState({ menu });
  };
  render() {
    const { order, isTask } = this.props;
    const isNew = !isTask && !(order && order.id !== undefined);
    return (
      <div className={`modem-wizard-title`}>
        <WizardTitle
          type="keyOrder"
          model={order}
          isNew={isNew}
          isTask={isTask}
          menu={this.state.menu}
        />
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(KeyOrderWizardTitle);
